module.exports = __webpack_public_path__ + "img/tutu.c01dc676.jpg";